import type { BottomDrawer } from '@jwplayer/wui-components';
import { snakeCase } from 'lodash-es';

import { UiStore } from '/global-state';
import { useCurrentRoute } from '/module/routing/hooks';

import { MAIN_NAV_CATEGORIES } from './config';
import { getMainNavLink } from './utils';

export const useNavigation = () => {
  const currentRoute = useCurrentRoute();
  const hideSiteSwitch = currentRoute?.uiOptions?.sideNav?.hidePropertySwitch;
  const isCollapsed = UiStore.useState((s) => s.sideNavCollapsed);
  const isPropertyDashboard = UiStore.useState((s) => s.isPropertyDashboard);

  if (currentRoute?.uiOptions?.sideNav?.forceCollapse) {
    UiStore.setState((s) => {
      s.sideNavCollapsed = true;
    });
  }

  if (currentRoute?.uiOptions?.pageType !== 'user-settings-dashboard' && !isPropertyDashboard) {
    UiStore.setState((s) => {
      s.isPropertyDashboard = true;
      s.sideNavCollapsed = false;
    });
  }

  if (currentRoute?.uiOptions?.pageType === 'user-settings-dashboard' && isPropertyDashboard) {
    UiStore.setState((s) => {
      s.isPropertyDashboard = false;
    });
  }

  const navigation = MAIN_NAV_CATEGORIES.map((category) => ({
    title: category.title,
    'data-test': `sidenav-section-${snakeCase(category.title)}`,
    links: category.items.map((item) => getMainNavLink(item)).filter((link) => link !== null),
  })).filter((category) => category.links.length > 0);

  const propertySettingsLink = getMainNavLink({
    name: 'Property settings',
    link: 'propertySettings',
    icon: 'settings',
  });

  const bottomDrawer: BottomDrawer = [
    ...(propertySettingsLink
      ? [
          {
            ...propertySettingsLink,
            type: 'link',
            'data-test': 'main-nav-link-property-settings',
          } as const,
        ]
      : []),
  ];

  return {
    navigation: !hideSiteSwitch ? navigation : [],
    bottomDrawer: !hideSiteSwitch ? bottomDrawer : [],
    isCollapsed,
    hideSiteSwitch,
  };
};
